import type { ComponentProps } from 'react';

import { Avatar, Text } from '@change/ds-core-ui/next';

import { Translate } from '@change-corgi/core/react/i18n';

import type { Comment } from '../../../../pageContext';

import { useCommentHeader } from './CommentHeader/hooks/useCommentHeader';
import { useCommentCard } from './hooks/useCommentCard';

type Props = {
	comment: Comment;
};

export function CommentCard({ comment, ...rest }: Props & ComponentProps<'div'>) {
	const {
		data: { comment: commentText },
	} = useCommentCard(comment);

	const {
		data: { author, authorAvatar, dateRelative },
	} = useCommentHeader(comment);

	return (
		<div {...rest} className="flex flex-row gap-2" data-qa={`comment-card-${comment.id}`} data-expanded>
			<div className="min-h-8 min-w-8">
				<Avatar alt="avatar" size="small" src={authorAvatar} />
			</div>
			<div className="flex flex-col justify-center gap-1">
				<Text as="p">
					<Text as="span">
						<b>{author}</b>{' '}
						<Translate value="corgi.petition.starter_dashboard.petition_comments.comments_list.commented_by" />{' '}
						{dateRelative}
					</Text>
				</Text>
				<blockquote>
					<Text as="div" className="whitespace-pre-wrap" data-qa="comment-body">
						&ldquo;{commentText}&rdquo;
					</Text>
				</blockquote>
			</div>
		</div>
	);
}
